import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5101131e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ba-header"
};
const _hoisted_2 = {
  class: "ba-row"
};
const _hoisted_3 = {
  class: "ba-left-side ba-column-relative"
};
const _hoisted_4 = {
  class: "daily-budget"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ba-text ba-text-small ba-text-lighter",
  style: {
    "display": "none"
  }
}, "Average daily budget available", -1));
const _hoisted_6 = {
  class: "ba-text ba-text-bold",
  style: {
    "display": "none"
  }
};
const _hoisted_7 = {
  class: "ba-circle",
  style: {
    "display": "none"
  }
};
const _hoisted_8 = {
  class: "ba-right-side"
};
const _hoisted_9 = {
  class: "weekly-budget"
};
const _hoisted_10 = {
  class: "ba-text ba-text-orange ba-text-bold"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ba-text ba-text-small ba-text-orange ba-text-lighter"
}, "Total weekly budget allocated", -1));
const _hoisted_12 = {
  class: "ba-row"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ba-left-side"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "total ba-text ba-text-small ba-text-lighter"
}, "Total →")], -1));
const _hoisted_14 = {
  class: "ba-right-side"
};
const _hoisted_15 = {
  class: "ba-perfomance ba-perfomance-top"
};
const _hoisted_16 = {
  class: "total-amount ba-text ba-text-purple"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100px",
    "height": "36px"
  }
}, null, -1));
const _hoisted_18 = {
  class: "total-variation-and-last-week-spend ba-text ba-text-right"
};
const _hoisted_19 = {
  key: 1,
  class: "ba-double-content",
  style: {
    "padding": "0px 4px",
    "gap": "2px",
    "color": "#93999F !important"
  }
};
const _hoisted_20 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "gap": "3px",
    "align-items": "center"
  }
};
const _hoisted_21 = {
  class: "ba-double-content-inner",
  style: {
    "color": "unset !important",
    "flex-direction": "column"
  }
};
const _hoisted_22 = {
  class: "ba-discovery ba-discovery-top"
};
const _hoisted_23 = {
  class: "total-amount ba-text"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100px",
    "height": "36px"
  }
}, null, -1));
const _hoisted_25 = {
  class: "total-variation-and-last-week-spend ba-text ba-text-right"
};
const _hoisted_26 = {
  key: 1,
  class: "ba-double-content",
  style: {
    "padding": "0px 4px",
    "gap": "2px",
    "color": "#93999F !important"
  }
};
const _hoisted_27 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "gap": "3px",
    "align-items": "center"
  }
};
const _hoisted_28 = {
  class: "ba-double-content-inner",
  style: {
    "color": "unset !important",
    "flex-direction": "column"
  }
};
const _hoisted_29 = {
  class: "ba-row"
};
const _hoisted_30 = {
  class: "ba-left-side"
};
const _hoisted_31 = {
  class: "ba-product-info top"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ba-product-info-block"
}, null, -1));
const _hoisted_33 = {
  class: "ba-product-info-groups"
};
const _hoisted_34 = {
  class: "search-box"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ba-product-info-prioritized"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "badge-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "badge ba-text ba-text-small"
}, "Prioritized by")])], -1));
const _hoisted_36 = {
  class: "ba-product-data ba-product-data-middle"
};
const _hoisted_37 = {
  class: "ba-product-data-content"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "switch-box"
}, null, -1));
const _hoisted_39 = {
  class: "switch-box"
};
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<div class=\"ba-right-side\" data-v-5101131e><div class=\"ba-perfomance ba-perfomance-middle\" data-v-5101131e><div class=\"ba-perfomance-content\" data-v-5101131e><div class=\"ba-column-title ba-text\" data-v-5101131e>Performance Targeting</div></div></div><div class=\"ba-discovery ba-discovery-middle\" data-v-5101131e><div class=\"ba-discovery-content\" data-v-5101131e><div class=\"ba-column-title ba-text\" data-v-5101131e>Discovery Targeting</div></div></div></div>", 1);
const _hoisted_41 = {
  class: "ba-row"
};
const _hoisted_42 = {
  class: "ba-left-side"
};
const _hoisted_43 = {
  class: "ba-product-info"
};
const _hoisted_44 = {
  class: "ba-product-info-block"
};
const _hoisted_45 = {
  class: "ba-product-info-block state",
  id: "amazon-status-sp"
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text",
  style: {
    "font-weight": "700"
  }
}, " Campaign(s) Status ", -1));
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " Live state of the campaign on Amazon Advertising ", -1));
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ba-product-info-groups"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "ba-column-title ba-text"
}, "Product Groups")], -1));
const _hoisted_49 = {
  class: "ba-product-info-prioritized"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "profit",
  class: "ba-product-info-prioritized-cell ba-column-title ba-text ba-text-right"
}, " Ads Net profit 4W ", -1));
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " Forecasted 4-week profit based on net ROAS from performance campaigns and last week's spend. ", -1));
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "revenue",
  class: "ba-product-info-prioritized-cell ba-column-title ba-text ba-text-right"
}, " 4-Week Rev. Share ", -1));
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " Percentage of total revenue over the last 28 days contributed by the products in this group. ", -1));
const _hoisted_54 = {
  class: "ba-product-data ba-product-data-bottom"
};
const _hoisted_55 = {
  class: "ba-product-data-content"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "margin",
  class: "ba-product-data-margin ba-column-title ba-text ba-text-right"
}, " Products Margin ", -1));
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " Weighted average margin rate over the last 28 days for the products in this group. ", -1));
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "boost",
  class: "ba-product-data-boost ba-column-title ba-text ba-text-right"
}, " Bid Mult. ", -1));
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " Multiplier applied to bids to increase exposure and visibility in ads. ", -1));
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "current4w",
  class: "ba-product-data-4w ba-column-title ba-text ba-text-right"
}, " Current - 4W ", -1));
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " 4-week ROAS from performance campaigns, calculated during the last run of the budget algorithm. ", -1));
const _hoisted_62 = {
  class: "ba-right-side"
};
const _hoisted_63 = {
  class: "ba-perfomance ba-perfomance-bottom"
};
const _hoisted_64 = {
  class: "ba-perfomance-content"
};
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "weeklyBudgetPerf",
  class: "ba-weekly ba-column-title ba-text ba-text-center"
}, " Weekly Budget ", -1));
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " 7 times the daily budget allocated for the campaigns. ", -1));
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "potentialPerf",
  class: "ba-pot ba-column-title ba-text ba-text-center"
}, " % of max spend pot. ", -1));
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " Maximum spend potential, estimated based on last week's daily max spend and time in budget. ", -1));
const _hoisted_69 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "vsPerf",
  class: "ba-last ba-column-title ba-text ba-text-right"
}, " vs. last week spend ", -1));
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " Difference between the current week's budget allocation and last week's actual spend. ", -1));
const _hoisted_71 = {
  class: "ba-discovery ba-discovery-bottom"
};
const _hoisted_72 = {
  class: "ba-discovery-content"
};
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "weeklyBudgetDiscovery",
  class: "ba-weekly ba-column-title ba-text ba-text-center"
}, " Weekly Budget ", -1));
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " 7 times the daily budget allocated for the campaigns. ", -1));
const _hoisted_75 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "potentialDiscovery",
  class: "ba-pot ba-column-title ba-text ba-text-center"
}, " % of max spend pot. ", -1));
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " Maximum spend potential, estimated based on last week's daily max spend and time in budget. ", -1));
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "vsDiscovery",
  class: "ba-last ba-column-title ba-text ba-text-right"
}, " vs. last week spend ", -1));
const _hoisted_78 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " Difference between the current week's budget allocation and last week's actual spend. ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_ppc_budget_allocation_circle = _resolveComponent("ppc-budget-allocation-circle");
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_calendar_with_arrow_left_icon = _resolveComponent("calendar-with-arrow-left-icon");
  const _component_app_input = _resolveComponent("app-input");
  const _component_app_switch = _resolveComponent("app-switch");
  const _component_announcement_icon_new = _resolveComponent("announcement-icon-new");
  const _component_amazon_icon = _resolveComponent("amazon-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("b", _hoisted_6, [_createVNode(_component_currency_value, {
    value: $options.availableBudget,
    full: true,
    currency: $props.currency,
    precision: $data.currency_precision,
    allowPrecisionModification: false
  }, null, 8, ["value", "currency", "precision"])])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_ppc_budget_allocation_circle, {
    percent: $options.percent
  }, null, 8, ["percent"])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("b", _hoisted_10, [$props.still_initializing ? (_openBlock(), _createBlock(_component_b_spinner, {
    key: 0,
    small: ""
  })) : (_openBlock(), _createBlock(_component_currency_value, {
    key: 1,
    value: $options.totalBudget,
    full: true,
    currency: $props.currency,
    precision: $data.currency_precision,
    allowPrecisionModification: false
  }, null, 8, ["value", "currency", "precision"]))]), _hoisted_11])])]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [$props.still_initializing ? (_openBlock(), _createBlock(_component_b_spinner, {
    key: 0,
    small: ""
  })) : (_openBlock(), _createBlock(_component_currency_value, {
    key: 1,
    value: $options.perfomanceTotalBudget,
    full: true,
    currency: $props.currency,
    precision: $data.currency_precision,
    allowPrecisionModification: false
  }, null, 8, ["value", "currency", "precision"]))]), _hoisted_17, _createElementVNode("div", _hoisted_18, [$props.still_initializing ? (_openBlock(), _createBlock(_component_b_spinner, {
    key: 0,
    small: "",
    style: {
      "align-self": "center"
    }
  })) : (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_calendar_with_arrow_left_icon), _createVNode(_component_currency_value, {
    value: $options.performanceTotalLastWeekSpend,
    currency: $props.currency,
    precision: $data.currency_precision,
    allowPrecisionModification: false
  }, null, 8, ["value", "currency", "precision"])]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_currency_value, {
    value: $options.performanceTotalVariation,
    currency: $props.currency,
    precision: $data.currency_precision,
    allowPrecisionModification: false,
    showSign: "",
    class: _normalizeClass(["ba-text", {
      'ba-text-red': $options.performanceTotalVariation < 0,
      'ba-text-green': $options.performanceTotalVariation > 0
    }])
  }, null, 8, ["value", "currency", "precision", "class"])])]))])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [$props.still_initializing ? (_openBlock(), _createBlock(_component_b_spinner, {
    key: 0,
    small: ""
  })) : (_openBlock(), _createBlock(_component_currency_value, {
    key: 1,
    value: $options.discoveryTotalBudget,
    full: true,
    currency: $props.currency,
    precision: $data.currency_precision,
    allowPrecisionModification: false
  }, null, 8, ["value", "currency", "precision"]))]), _hoisted_24, _createElementVNode("div", _hoisted_25, [$props.still_initializing ? (_openBlock(), _createBlock(_component_b_spinner, {
    key: 0,
    small: "",
    style: {
      "align-self": "center"
    }
  })) : (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_calendar_with_arrow_left_icon), _createVNode(_component_currency_value, {
    value: $options.discoveryTotalLastWeekSpend,
    currency: $props.currency,
    precision: $data.currency_precision,
    allowPrecisionModification: false
  }, null, 8, ["value", "currency", "precision"])]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_currency_value, {
    value: $options.discoveryTotalVariation,
    currency: $props.currency,
    precision: $data.currency_precision,
    allowPrecisionModification: false,
    showSign: "",
    class: _normalizeClass(["ba-text", {
      'ba-text-red': $options.discoveryTotalVariation < 0,
      'ba-text-green': $options.discoveryTotalVariation > 0
    }])
  }, null, 8, ["value", "currency", "precision", "class"])])]))])])])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_hoisted_32, _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createVNode(_component_app_input, {
    modelValue: $options.localSearch,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.localSearch = $event),
    v2: "",
    prependIcon: "search",
    prependSimple: "",
    version: "ba-search",
    placeholder: "Search..."
  }, null, 8, ["modelValue"])])]), _hoisted_35]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_hoisted_38, _createElementVNode("div", _hoisted_39, [_createElementVNode("div", {
    class: _normalizeClass(['ba-text', {
      'ba-text-lighter': $props.mode === 'acos'
    }])
  }, " ROAS ", 2), _createVNode(_component_app_switch, {
    modelValue: $options.localMode,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $options.localMode = $event),
    options: $data.modes,
    between: ""
  }, null, 8, ["modelValue", "options"]), _createElementVNode("div", {
    class: _normalizeClass(['ba-text', {
      'ba-text-lighter': $props.mode === 'roas'
    }])
  }, " ACOS ", 2)])])])]), _hoisted_40]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createVNode(_component_announcement_icon_new)]), _createElementVNode("div", _hoisted_45, [_createVNode(_component_amazon_icon), _createVNode(_component_app_popover, {
    target: "amazon-status-sp",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_46, _hoisted_47]),
    _: 1
  })]), _hoisted_48]), _createElementVNode("div", _hoisted_49, [_hoisted_50, _createVNode(_component_app_popover, {
    target: "profit",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_51]),
    _: 1
  }), _hoisted_52, _createVNode(_component_app_popover, {
    target: "revenue",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_53]),
    _: 1
  })]), _createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_hoisted_56, _createVNode(_component_app_popover, {
    target: "margin",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_57]),
    _: 1
  }), _hoisted_58, _createVNode(_component_app_popover, {
    target: "boost",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_59]),
    _: 1
  }), _hoisted_60, _createVNode(_component_app_popover, {
    target: "current4w",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_61]),
    _: 1
  })])])]), _createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_hoisted_65, _createVNode(_component_app_popover, {
    target: "weeklyBudgetPerf",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_66]),
    _: 1
  }), _hoisted_67, _createVNode(_component_app_popover, {
    target: "potentialPerf",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_68]),
    _: 1
  }), _hoisted_69, _createVNode(_component_app_popover, {
    target: "vsPerf",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_70]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_71, [_createElementVNode("div", _hoisted_72, [_hoisted_73, _createVNode(_component_app_popover, {
    target: "weeklyBudgetDiscovery",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_74]),
    _: 1
  }), _hoisted_75, _createVNode(_component_app_popover, {
    target: "potentialDiscovery",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_76]),
    _: 1
  }), _hoisted_77, _createVNode(_component_app_popover, {
    target: "vsDiscovery",
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_78]),
    _: 1
  })])])])])]);
}